import { SearchInputFilterItems } from "features/filters/components";

import { typedObjectEntries } from "common/helpers/utils";

import { ACCOUNTS_FILTERS } from "../constants";

import type { AccountSearchParams } from "../types";

export default function AccountFilterOptions<
  SearchParamsKey extends keyof AccountSearchParams,
>({
  searchParamsKey,
  searchParams,
  setSearchParams,
}: {
  searchParamsKey: SearchParamsKey;
  searchParams: AccountSearchParams;
  setSearchParams: (searchParams: AccountSearchParams) => void;
}) {
  function toggleParam(
    optionKey: AccountSearchParams[SearchParamsKey][number],
  ) {
    const isSelected = searchParams[searchParamsKey].find(
      (value) => value === optionKey,
    );
    const updatedParams = isSelected
      ? searchParams[searchParamsKey].filter(
          (selectedParam) => selectedParam !== optionKey,
        )
      : [...searchParams[searchParamsKey], optionKey];

    setSearchParams({
      ...searchParams,
      [searchParamsKey]: updatedParams,
    });
  }

  return (
    <SearchInputFilterItems
      getFilteredItems={(lowercaseSearchKeyword) =>
        typedObjectEntries(ACCOUNTS_FILTERS[searchParamsKey].options)
          .filter(([, label]) =>
            label.toLowerCase().includes(lowercaseSearchKeyword),
          )
          .map(([key]) => ({ id: key }))
      }
      renderLabel={({ id }) => ACCOUNTS_FILTERS[searchParamsKey].options[id]}
      getIsChecked={({ id }) =>
        !!searchParams[searchParamsKey].find((value) => value === id)
      }
      onSelectionChange={(type, { id }) => {
        if (type === "toggle") {
          toggleParam(id);
        } else if (type === "select") {
          setSearchParams({ ...searchParams, [searchParamsKey]: [id] });
        }
      }}
      isLoading={false}
    />
  );
}
